import { axiosApiInstance } from "@/libs/axios";
import { API_ENDPOINTS } from "@/constants/api";

export interface StudentSearchResult {
  id: string;
  name: string;
  avatar_path: string;
}

export interface SearchStudentsResponse {
  data: StudentSearchResult[];
}

export const searchStudents = async (email: string): Promise<SearchStudentsResponse> => {
  const response = await axiosApiInstance.post(
    API_ENDPOINTS.WORKSPACES.INVITATIONS.SEARCH_STUDENTS,
    {
      email,
    },
  );

  return response.data;
};
